import { render, staticRenderFns } from "./SummaryHomework.vue?vue&type=template&id=c86059a6&scoped=true"
import script from "./SummaryHomework.vue?vue&type=script&lang=ts"
export * from "./SummaryHomework.vue?vue&type=script&lang=ts"
import style0 from "./SummaryHomework.vue?vue&type=style&index=0&id=c86059a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86059a6",
  null
  
)

export default component.exports